export const SubscriptionsRels = {
    getSubscriptions: 'getSubscriptions',
    getSubscription: 'getSubscription',
    updateSubscription: 'updateSubscription',
    deleteSubscription: 'deleteSubscription',
    createSubscription: 'createSubscription'
};
